import { Link } from 'react-router-dom';

export const FSBOHero = () => {
  return (
    <section className="relative min-h-[85vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/2063d8ff98ea995da0e704882630f92f.jpg"
          alt="For Sale by Owner apartment building direct transaction"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>
      
      <div className="relative z-10 max-w-5xl mx-auto px-6 py-20 text-center text-white">
        <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
          Sell Your Apartment Building For Sale by Owner
        </h1>
        <p className="text-xl md:text-2xl mb-8 text-white/95 max-w-3xl mx-auto leading-relaxed">
          Skip the agent commissions, protect tenant privacy, and structure a tax-advantaged sale directly with qualified buyers
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Link 
            to="/we-buy-apartment-buildings"
            className="px-8 py-4 bg-teal-500 text-white rounded-lg font-semibold hover:bg-teal-600 transition-all shadow-lg hover:shadow-xl whitespace-nowrap"
          >
            Get Your Private Offer
          </Link>
          <a 
            href="#fsbo-benefits"
            className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white rounded-lg font-semibold hover:bg-white/20 transition-all border border-white/30 whitespace-nowrap"
          >
            Learn FSBO Benefits
          </a>
        </div>
        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl mx-auto">
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 border border-white/20">
            <div className="text-3xl font-bold text-teal-400 mb-2">0%</div>
            <div className="text-sm text-white/90">Agent Commission</div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 border border-white/20">
            <div className="text-3xl font-bold text-teal-400 mb-2">Private</div>
            <div className="text-sm text-white/90">Confidential Sale</div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 border border-white/20">
            <div className="text-3xl font-bold text-teal-400 mb-2">Custom</div>
            <div className="text-sm text-white/90">Tax Structuring</div>
          </div>
        </div>
      </div>
    </section>
  );
};